import { render } from "./CompletedSupportRequest.vue?vue&type=template&id=781e0142&scoped=true"
import script from "./CompletedSupportRequest.vue?vue&type=script&lang=js"
export * from "./CompletedSupportRequest.vue?vue&type=script&lang=js"

import "./CompletedSupportRequest.vue?vue&type=style&index=0&id=781e0142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781e0142"]])

export default __exports__